module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_bronze-ef1243c34d2c6442b1781b281adf7dcb.png";